'use client';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import EllipsisVertical from '../../icons/EllipsisVertical';
import idsTokensDefault from '../../utils/tokens/idsTokens';
import IconMenuButton from '../IconMenuButton';

export const styles = ({ idsTokens = idsTokensDefault }) => ({
  button: {
    marginRight: 7,
  },
  smallMenuItem: {
    height: 32,
    fontSize: idsTokens.typography.font.size.sm,
  },
});

const useStyles = makeStyles()(styles);

const NotificationsSubMenu = ({ actionsMenuItems }) => {
  const { classes } = useStyles();

  return (
    <IconMenuButton
      id="apollo-react-notifications-actions-menu"
      className={classes.button}
      size="small"
      menuItems={actionsMenuItems}
      placement="bottom-end"
    >
      <EllipsisVertical fontSize="small" />
    </IconMenuButton>
  );
};

export default NotificationsSubMenu;
